import { render, staticRenderFns } from "./UserEditorPermissions.vue?vue&type=template&id=b3f95aa2&"
import script from "./UserEditorPermissions.vue?vue&type=script&lang=js&"
export * from "./UserEditorPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports